import { render, staticRenderFns } from "./Njoftimet.vue?vue&type=template&id=121b5fef"
import script from "./Njoftimet.vue?vue&type=script&lang=js"
export * from "./Njoftimet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports